import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ThemeQuery } from './ThemeQuery.graphql.ts';

export function preloadPageLayout() {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ThemeQuery,
	});
}
